

























































































import { Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";

import SelectUsers from "@/components/selectusers.vue";
import SelectStadium from "@/components/selectstadium.vue";

@Component({
  components: {
    SelectUsers,
    SelectStadium
  }
})
export default class extends Mixins(MyList) {
  refundModalVisible = false;

  oldData: any = {};

  // 操作搜索栏的展开和折叠
  isFlag = false;

  dispatchType = "bill/devops";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "头像", scopedSlots: { customRender: "avatar" } },
    { title: "会员名/昵称", scopedSlots: { customRender: "username" } },
    { title: "城市", dataIndex: "city" },
    { title: "场馆", dataIndex: "stadium_name" },
    { title: "订单类型", scopedSlots: { customRender: "product_name" }},
    { title: "时间", dataIndex: "created_time" },
    { title: "金额", scopedSlots: { customRender: "fee" } },
    { title: "状态", scopedSlots: { customRender: "is_pay" } },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    this.loadData();
  }

  convertNum(d:any){
    return parseInt(d)
  }
}
